import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { selectCartItems } from "../Redux/shoppingCartReducer";
import "../i18n/config";
import i18next from "i18next";
import { Row, Col, Form, Spinner } from "react-bootstrap";
import ShoppingCartComponent from "./ShoppingCart";
import PersonalDetailsFormComponent from "./PersonalDetails";
import apiService from "../services/api.service";
import { useForm } from "react-hook-form";
import CountdownTimer from './CountdownTimer';
import { useCountdown } from './useCountdown';
import moment from "moment";
import { ErrorCodes, OrderStatus } from "../data/enums";
import CompanyRegistrationForm from "../components/CompanyComponents/CompanyRegistrationForm";
import { eventService } from "../services/event.service";
import Company from "./CompanyComponents/Company";
import ProductSummaryRows from "./DailyInventoryComponents/ProductSummaryRows";
import { useTranslation } from "../hooks/useTranslation";
import {sendFlashyEcommerceEvent, _ECOMMERCE_FLASHY_EVENT} from "../hooks/flashy-events"
function RegistrationComponent(props) {
  const {
    register,
    handleSubmit,
    setValue,
    setFocus,
    watch,
    trigger,
    getValues,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
  });

  const [lang, setLang] = useState("");
  const [pciIframeSrc, setPciIframeSrc] = useState("");
  const [isPaymentStep, setIsPaymentStep] = useState(false);
  const { t, translations } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const [orderStatusId, setOrderStatusId] = useState(null)
  const [agreeToReceiveEmailsChecked, setAgreeToReceiveEmailsChecked] = useState(false);
  const chain = useSelector((state) => state.chain);
  const chainId = new URLSearchParams(location.search).get("chainid") || 0;
  const propertyId = new URLSearchParams(location.search).get("propid") || 0;
  let reduxIsPayment = useSelector((state) => state.cart.payment.payload);
  const productBlockingIdentifier = window.sessionStorage.getItem("productBlockingIdentifier");
  const productBlockingIdentifierTime = window.sessionStorage.getItem("productBlockingIdentifierTime");
  const company = useSelector((state) => state.company.company)
  const workers = useSelector((state) => state.company.workers)
  const companyDataCart = useSelector((state) => state.cart.companyData)
  let expSeconds = 60;
  let expMin = 10;
  const expirationTimeTxt = expMin + " " + t("ExpTimeTxt");
  let EXP_TIME_IN_MS = expMin * expSeconds * 1000;
  const BlockTime_IN_MS = new Date(productBlockingIdentifierTime).getTime();
  const expirationTime = BlockTime_IN_MS + EXP_TIME_IN_MS;
  const [days, hours, minutes, seconds] = useCountdown(expirationTime);
  let RDRCT_TIME_IN_MS = minutes < 0 ? 0 : ((minutes * expSeconds) + (seconds + 3)) * 1000;
  const companyUser = useSelector((state) => state.company.companyUser)
  const PCI_API_DOMAIN = process.env.REACT_APP_PCI_API_DOMAIN;
  const [loading, setLoading] = useState(false)
  const [selectMopMsg, setSelectMopMsg] = useState("")
  const [sendToGifteeTime, setSendToGifteeTime] = useState(null)
  const [sendNow, setSendNow] = useState(true)
  let cartItems = useSelector(selectCartItems);
  const [customerDetails, setCustomerDetails] = useState(null);
  const qty = cartItems[Object.keys(cartItems)[0]].qty;
  const product = cartItems[Object.keys(cartItems)[0]].selectedProduct;

  const SetLanguage = (l) => {
    i18next.changeLanguage(l);
  };
  const handleDetailsSubmit = (details) => {
    setCustomerDetails(details);
};
  //handle send gift time 
  useEffect(() => {
    if (!sendNow) {
      if (getValues('gifteeDate') && getValues('gifteeTime')) {
        const date = getValues('gifteeDate')
        const time = getValues('gifteeTime').split(':')
        setSendToGifteeTime(
          moment(date)
            .hour(time[0])
            .minute(time[1])
            .format("YYYY-MM-DD[T]HH:mm:ss"))
      }
    } else {
      setSendToGifteeTime(null)
    }
  }, [watch('gifteeDate'), watch('gifteeTime'), sendNow])
  useEffect(() => {
    if (cartItems && Object.keys(cartItems).length > 0) {
        const productIds = Object.values(cartItems).map(item => item.selectedProduct.productId);
        const totalValue = Object.values(cartItems).reduce(
          (sum, item) => sum + item.qty * item.selectedProduct.productPrice, 
          0
        );
        const data = {
          'content_ids': productIds,
          'value': totalValue,
          'currency': Object.values(cartItems)[0]?.selectedProduct.currencyCode
        };
        sendFlashyEcommerceEvent(_ECOMMERCE_FLASHY_EVENT.UPDATE_CART, data, 'flashy');
        
    }
}, [cartItems]);
  useEffect(() => {
    setLang(new URLSearchParams(location.search).get("lang") || "eng");
    window.addEventListener("message", processIframeResponse, false);
    if (window.parent === window.self) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.parent.postMessage({ toScroll: true }, '*');
      console.info('dispatch event to scroll!');
    }

    if (productBlockingIdentifier) {
      console.log(RDRCT_TIME_IN_MS);
      setTimeout(() => {
        unblockProduct(productBlockingIdentifier);
        history.push(`/?chainid=${chainId}&lang=${new URLSearchParams(location.search).get("lang")}`);

      }, RDRCT_TIME_IN_MS);

    }
    else {
      history.push(`/?chainid=${chainId}&lang=${new URLSearchParams(location.search).get("lang")}`);
    }

    return () => {
      window.removeEventListener("message", processIframeResponse);
    };
  }, []);

  useEffect(() => {
    document.title = t("PageTitleRegistration");
  }, [translations]);


  useEffect(() => {
    SetLanguage(lang);
  }, [lang]);


  useEffect(() => {
    setIsPaymentStep(reduxIsPayment)
  }, [reduxIsPayment])

  useEffect(() => {
    if (typeof lang === "string" && lang !== "" && isPaymentStep && !companyUser) {

      const payerName = window.sessionStorage.getItem("payerName");
      const payerCompID = window.sessionStorage.getItem("payerCompID");
      getPaymentHTML(payerName, payerCompID);
    }

    if (typeof lang === "string" && lang !== "" && isPaymentStep && companyUser) {

      const payerName = company.companyName
      const payerCompID = company.companyVatNumber;
      getPaymentHTML(payerName, payerCompID);
    }
  }, [isPaymentStep, lang]);
  useEffect(() => {
    if (isPaymentStep && customerDetails) {
        const data = {
            'email': customerDetails.email,
            'first_name': customerDetails.firstName,
            'last_name': customerDetails.lastName,
            groupId: chain?.translations?.find(t => t.languageIsoCode == lang)?.newsletterGeneralGroupId,
            'acceptNews': agreeToReceiveEmailsChecked
        };

        sendFlashyEcommerceEvent(_ECOMMERCE_FLASHY_EVENT.CREATE_OR_UPDATE, data, 'flashy');
        
    }
}, [isPaymentStep, customerDetails]);
  const onInsertCartInProgressComplete = () => {
    setIsPaymentStep(true);
  };

  const unblockProduct = (productBlockingIdentifier) => {
    sessionStorage.removeItem('productBlockingIdentifier');
    sessionStorage.removeItem('productBlockingIdentifierTime');
    sessionStorage.removeItem('products');

    apiService.unblockProduct(productBlockingIdentifier).then(
      (response) => {

      },
      (error) => { });
  };

  const completeOrder = (bookingID) => {
    let orderNum = bookingID || sessionStorage.getItem("lastOrderNum") || 0;
    let productLastSearchId =
      sessionStorage.getItem("productLastSearchId") || 0;
    let searchesArray = [];
    searchesArray.push(productLastSearchId);
    let lastCustomer = sessionStorage.getItem("lastCustomer") || null;
    if (companyUser) {
      sessionStorage.setItem("orderStatusId", OrderStatus.Reserved)
      apiService.updateOrders(chainId, orderNum, OrderStatus.Reserved, null).then(() => {
        history.push(
          `/confirmation?chainid=${chainId}&lang=${new URLSearchParams(
            location.search
          ).get("lang")}`
        );
      })
        .catch((err) => {
          console.error(err);
          alert("Failed to complete Company order.");
        });
    }
    if (lastCustomer && !companyUser) {
      var updatedCustomer = JSON.parse(lastCustomer);
      apiService.getCustomer(updatedCustomer.customerEmail).then(
        (response) => {
          if (response.data.data && response.data.data.length > 0) {
            var custId =
              response.data.data[response.data.data.length - 1].customerId;
            // setCustomerId(custId);

            //update the order number and customerid in searches table
            apiService.insertSearch(
              null,
              productLastSearchId,
              orderNum,
              custId,
              false,
              null
            );

            updatedCustomer.customerId = custId;

            // update order status , searches and customerID
            apiService
              .updateOrder(
                chainId,
                orderNum,
                OrderStatus.Reserved,
                null,
                searchesArray,
                updatedCustomer,
                product && product.propertyId ? product.propertyId : 0,
              )
              .then((res) => {
                history.push(
                  `/confirmation?chainid=${chainId}&lang=${new URLSearchParams(
                    location.search
                  ).get("lang")}`
                );
              })
              .catch((err) => {
                console.error(err);
                alert("Failed to complete order.");
              });
          }
        },
        (error) => {
          const _content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          alert("Failed to complete order.");
        }
      );
    }
  };

  const processIframeResponse = (event) => {
    let completedOrder = sessionStorage.getItem("completedOrder") || null;
    if (event.origin !== PCI_API_DOMAIN || completedOrder) return;
    // Parse message back to json
    const messageObject = JSON.parse(event.data);
    if (messageObject.action == "pciReponse" && messageObject.result == true && !completedOrder) {
      completeOrder(messageObject.bookingID);
      sessionStorage.setItem("completedOrder", "true");

      eventService.addPaymentInfo(product);
    }
    else {
      alert(t("paymentFailed") + " , " + messageObject.description);
      const payerName = window.sessionStorage.getItem("payerName");
      const payerCompID = window.sessionStorage.getItem("payerCompID");

      if (payerName && payerName.length && payerCompID) {
        getPaymentHTML(payerName, payerCompID);
      }
      else {
        getPaymentHTML("");
      }
    }
  };
  const getPCIframe = (chainId, orderNum, payBy, payerCompID, isGroupId) => {

    setLoading(true)
    apiService
      .getPCIframe(
        chainId,
        new URLSearchParams(location.search).get("lang"),
        propertyId > 0 ? propertyId : product && product.propertyId ? product.propertyId : 0,
        orderNum,
        payBy,
        payerCompID,
        isGroupId,
      )
      .then((response) => {
        if (response.data.data) {
          let iframeSrc = response.data.data;
          setPciIframeSrc(iframeSrc);
        } else {
          console.error(response.data.data);
          alert(t("SomethingWentWrong") + "\n" + t("ErrorCode") + ErrorCodes.GetPciIframe);
        }
      }, (err) => {
        console.error(err);
        alert(t("SomethingWentWrong") + "\n" + t("ErrorCode") + ErrorCodes.GetPciIframe);
        setIsPaymentStep(false);
      })
      .finally(() => {
        setLoading(false);
      })
  }

  const findOrCreateCustomer = async (email) => {


    const extractCustomerId = (response) => {
      const data = response.data.data;
      return data && data.length ? data[0].customerId : null;
    };

    try {
      // 1. Check by the provided email (companyUser Email)
      const primaryResponse = await apiService.getCustomer(email);
      const primaryId = extractCustomerId(primaryResponse);
      if (primaryId) return primaryId;

      // 2. Not found — create a new customer
      const newCustomer = {
        customerAddress: "",
        customerCity: "",
        customerCountry: "",
        customerEmail: companyUser.customerEmail,
        customerPhone: companyUser.customerPhone,
        customerFirstName: companyUser.customerFirstName,
        customerLastName: companyUser.customerLastName,
        customerId: 0,
        customerIdentification: "",
        // customerLanguageIsoCode: company.companyContactLanguageIsoCode,
        customerPostalCode: "",
        companyId: company.companyId,
      };
      const createResponse = await apiService.setCustomer(newCustomer);
      return createResponse.data.data;  //new customer id

    } catch (error) {
      console.error('findOrCreateCustomer failed:', error);
      throw new Error("customerId not found"); // re-throw so the caller can handle it (e.g. show an error message)
    }
  };

  const getPaymentHTML = (payBy, payerCompID) => {
    let orderNum = sessionStorage.getItem("lastOrderNum") || 0;
    if (!orderStatusId) {
      setSelectMopMsg(t("ChoosePaymentMethod"))
    }
    if (companyUser && company && orderStatusId) {
      setSelectMopMsg("")
      setLoading(true)
      let customerIp;
      let giftees = []
      if (workers) {
        workers.map((worker) => {
          giftees.push(
            {
              gifteeEmail: worker.workerEmail,
              gifteeName: worker.workerFirstName + " " + worker.workerLastName,
              gifteePhone: worker.workerPhone,
            })
        })

      }

      apiService.getUserIp()
        .then((r) => {
          customerIp = r
          let payerName = company.companyName
          let productId = product.productId
          let quantity = (Object.values(cartItems)[0].qty)
          let languageIsoCode = lang
          let customerBrowserAgent = null
          let gifteeMsg = companyDataCart.greetingText || null

          let customerId = null
          let isProductAvailable = false;
          findOrCreateCustomer(companyUser.customerEmail)
            .then((response) => {
              customerId = response

              if (productBlockingIdentifier && productId) {
                apiService.getBlockedProduct(productId, productBlockingIdentifier)
                  .then(response => {
                    if (!response.errors && response.data && response.data.data && response.data.data.length) {
                      if (response.data.data[0].isValid) {
                        isProductAvailable = true;
                      } else {
                        alert(t("ProductNotAvailableAnymore"));
                      }
                    } else {
                      alert(t("ProductNotAvailableAnymore"));
                    }
                  })
                  .finally(() => {
                    if (isProductAvailable) {
                      apiService.setOrders(chainId, productId, quantity, gifteeMsg, languageIsoCode, customerIp, customerBrowserAgent, orderStatusId, giftees, sendToGifteeTime, company.companyId, customerId)
                        .then((r) => {
                          orderNum = r.data.data.groupOrderId
                          sessionStorage.setItem("lastOrderNum", orderNum)
                          sessionStorage.setItem("orderStatusId", orderStatusId)

                          if (orderStatusId == OrderStatus.Pending) {
                            history.push(
                              `/confirmation?chainid=${chainId}&lang=${new URLSearchParams(
                                location.search
                              ).get("lang")}`
                            );
                          } else {
                            getPCIframe(chainId, orderNum, company.companyName, company.companyId, true)
                          }
                        })
                        .finally(() => {
                          setLoading(false);
                        })
                    } else {
                      alert(t("ProductNotAvailableAnymore"));
                      setLoading(false);
                    }
                  })
              }
            })
            .catch(err => {
              alert(t("SomethingWentWrong") + "\n" + t("ErrorCode") + ErrorCodes.GetUserIp);
              setLoading(false);
            })
        })
        .catch(err => {
          alert(t("SomethingWentWrong") + "\n" + t("ErrorCode") + ErrorCodes.GetUserIp);
          setLoading(false);
        })
    }
    if (!companyUser) {
      getPCIframe(chainId, orderNum, payBy, payerCompID, false)
    }
  }
  const scrollToReg = () => {
    const element = document.getElementById('reg');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    scrollToReg()
  }, [])

  return (
    <div className="registration-page-wrap">
      <Row className="col-container">
        <Col className="box-wrap">
          <div className="box rvs-dtl">
            {companyUser &&
              <div className="hidden-desk">
                <Company />
                <div className="border-underline-big"></div>
              </div>
            }
            <h2 aria-label={t("ReservationDetails")} className={companyUser ? 'top-line comp-color' : 'top-line'}>{t("ReservationDetails")}</h2>
            {
              // product with daily inventory 
              product.enableDailyInventory ?
                <ProductSummaryRows
                  qty={qty}
                  lang={lang}
                  product={product}
                />
                :
                //regular product
                <ShoppingCartComponent
                  setValue={setValue}
                  sendNow={sendNow}
                  setSendNow={setSendNow}
                  register={register}
                  errors={errors}
                  handleSubmit={handleSubmit}
                  watch={watch}
                ></ShoppingCartComponent>
            }
          </div>
        </Col>
        <Col lg="4" className="box-wrap">
          {!companyUser ?
            <>
              <div className="box reg-form">
                <h2 aria-label={!isPaymentStep ? t("UserDetails") : t("PaymentDetails")} className="top-line" id="details-label">
                  {!isPaymentStep ? t("UserDetails") : <Row> <Col>{t("PaymentDetails")} </Col> <Col className="secured-pay-wrap"><span className="pay-icn"> </span> <span className="pay-txt">{t("SecurePay")}</span></Col></Row>}

                </h2>
                {productBlockingIdentifier ?
                  <div className="count-down-wrap">
                    <div role="application" aria-roledescription={t("Attention")} aria-label={t("ExpirationText").replace("[0]", expirationTimeTxt)}>{t("ExpirationText").replace("[0]", expirationTimeTxt)} </div>
                    <span role="application" aria-roledescription={t("Attention")} aria-label={t("RemainedExpirationTimeText") + (new Date(RDRCT_TIME_IN_MS).getMinutes() + " " + t("Mins")) + " " + (new Date(RDRCT_TIME_IN_MS).getSeconds() - 3 + " " + t("Seconds"))}>{t("RemainedExpirationTimeText")}</span>
                    <CountdownTimer targetDate={expirationTime} />
                  </div>

                  : ""}
                {!isPaymentStep && (
                  <PersonalDetailsFormComponent
                    register={register}
                    errors={errors}
                    handleSubmit={handleSubmit}
                    onInsertCartInProgressComplete={onInsertCartInProgressComplete}
                    completeOrder={completeOrder}
                    setValue={setValue}
                    setFocus={setFocus}
                    setLoading={setLoading}
                    loading={loading}
                    sendToGifteeTime={sendToGifteeTime}
                    onDetailsSubmit={handleDetailsSubmit}
                    agreeToReceiveEmailsChecked={agreeToReceiveEmailsChecked}
                    setAgreeToReceiveEmailsChecked={setAgreeToReceiveEmailsChecked}
                  ></PersonalDetailsFormComponent>
                )}
                {isPaymentStep && (
                  <div id="pci-iframe-holder">
                    <iframe
                      title={t("PaymentFrame")}
                      frameBorder={0}
                      scrolling="yes"
                      allowtransparency="true"
                      src={pciIframeSrc}
                    ></iframe>
                    <h4 className="orderNameMsg" dangerouslySetInnerHTML={{ __html: t("OrderNameMsg").replace('\n', "<br/>").replace("&nbsp;", "&nbsp;").replaceAll("'", JSON.stringify("").charAt(0)) }}></h4>
                  </div>
                )}
              </div>
            </>
            :
            <>
              {companyUser && !pciIframeSrc &&
                <CompanyRegistrationForm
                  loading={loading}
                  company={company}
                  companyUser={companyUser}
                  selectMopMsg={selectMopMsg}
                  orderStatusId={orderStatusId}
                  getPaymentHTML={getPaymentHTML}
                  expirationTime={expirationTime}
                  setOrderStatusId={setOrderStatusId}
                  RDRCT_TIME_IN_MS={RDRCT_TIME_IN_MS}
                  expirationTimeTxt={expirationTimeTxt}
                  productBlockingIdentifier={productBlockingIdentifier}
                />
              }
              {pciIframeSrc && orderStatusId != OrderStatus.Pending &&
                <div className="box reg-form">
                  <h2 className="top-line">
                    <Row> <Col>{t("PaymentDetails")} </Col> <Col className="secured-pay-wrap"><span className="pay-icn"> </span> <span className="pay-txt">{t("SecurePay")}</span></Col></Row>
                  </h2>
                  <div id="pci-iframe-holder">
                    <iframe
                      frameBorder={0}
                      scrolling="yes"
                      allowtransparency="true"
                      src={pciIframeSrc}
                    ></iframe>
                    <h4 className="orderNameMsg" dangerouslySetInnerHTML={{ __html: t("OrderNameMsg").replace('\n', "<br/>").replace("&nbsp;", "&nbsp;").replaceAll("'", JSON.stringify("").charAt(0)) }}></h4>
                  </div>
                </div>
              }
            </>
          }
        </Col>
      </Row>
    </div>
  );
}

export default RegistrationComponent;
